import getLogger from 'src/utils/logger'
import type { HttpClient, ApiConfig } from 'src/api/httpClient'

const logger = getLogger('CreateClient')

const createClient = <T extends HttpClient>(ApiClient: new (config: ApiConfig) => T, extraConfig: ApiConfig): T => {
  const { baseURL = process.env.NEXT_PUBLIC_API_URL, ...restConfig } = extraConfig
  if (!baseURL) {
    logger.error('Base URL is not defined in the configuration')
  }
  const apiClient = new ApiClient({
    baseURL,
    ...restConfig,
  })

  return apiClient
}

export default createClient
